var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16543 2.56201C6.40763 2.56201 6.63076 2.69335 6.74833 2.9051L7.56379 4.37403C7.67056 4.56637 7.67559 4.799 7.57719 4.99577L6.79159 6.567C6.79159 6.567 7.01926 7.73747 7.97206 8.69027C8.92486 9.64307 10.0914 9.8668 10.0914 9.8668L11.6624 9.08133C11.8593 8.98287 12.0921 8.98797 12.2845 9.09494L13.7576 9.91394C13.9691 10.0316 14.1003 10.2546 14.1003 10.4966V12.1878C14.1003 13.049 13.3004 13.671 12.4843 13.3957C10.8084 12.8302 8.20679 11.7534 6.55786 10.1045C4.90889 8.45553 3.83216 5.85397 3.26665 4.178C2.99131 3.36197 3.61334 2.56201 4.47456 2.56201H6.16543Z",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6c93c26367fac5a162437d7b74ff1f6a.svg";
export { ForwardRef as ReactComponent };